import React, { PropsWithChildren } from 'react';
import { classNames } from 'primereact/utils';
import { Icon, IconProps } from '../Icon';

export type ContentSectionProps = PropsWithChildren<{
	titleIconProps: IconProps;
	title: string;
	className?: string;
}>;

export const ContentSection = ({ titleIconProps, title, className, children }: ContentSectionProps) => {
	return (
		<div className={classNames('flex flex-column gap-2', className)}>
			<h2 className="text-xl">
				<Icon {...titleIconProps} className={classNames('text-semirose mr-3', titleIconProps.className)} />
				<span>{title}</span>
			</h2>
			{children}
		</div>
	);
};
